import { useMutation, useQueryClient } from '@tanstack/react-query';
import useGlynt from '../useGlynt';
import { IRQCallbacks } from '../../../types/my-types';

const useApproveChangeTicket = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: number) => {
      return (await glynt).vendor.approveChangeTicket(id);
    },

    ...callbacks,

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ['vendor-change-tickets']
      });
      queryClient.invalidateQueries({
        queryKey: ['vendors']
      });
      queryClient.invalidateQueries({
        queryKey: ['mat-discovery-full']
      });
    }
  });
};

export default useApproveChangeTicket;
